import { Link } from "react-router"
import { Wallet, Tag, Repeat, Activity, CreditCard, ChevronRight } from "lucide-react"
import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"
import { useAuth } from "@/lib/auth-context"
import { useProfiles } from "@/lib/hooks"

const menuItems = [
  {
    to: "/settings/categories",
    icon: Wallet,
    title: "カテゴリーと予算",
  },
  {
    to: "/tags",
    icon: Tag,
    title: "タグ",
  },
  {
    to: "/recurring",
    icon: Repeat,
    title: "固定費（繰り返しの支出）",
  },
  {
    to: "/settings/payment-methods",
    icon: CreditCard,
    title: "支払い方法（カード・口座）",
  },
  {
    to: "/settings/api-usage",
    icon: Activity,
    title: "AI解析履歴",
  },
]

export default function SettingsPage() {
  const { user } = useAuth()
  const { data: profiles = [] } = useProfiles()

  const currentProfile = profiles.find((p) => p.id === user?.id)
  const profile = currentProfile
    ? {
        display_name: currentProfile.display_name,
        avatar_url: currentProfile.avatar_url,
        email: user?.email || "",
      }
    : null
  const profileLoading = !currentProfile && profiles.length === 0

  return (
    <div className="bg-background">
      <div className="mx-auto max-w-lg px-4 py-6">
        <h1 className="mb-6 text-xl font-semibold">設定</h1>

        {/* Profile card */}
        <Link to="/settings/account" className="block">
          <Card className="mb-6 py-0 transition-colors hover:bg-accent">
            <CardContent className="flex items-center gap-4 px-4 py-4">
              {profileLoading ? (
                <>
                  <Skeleton className="size-12 rounded-full" />
                  <div className="flex-1 space-y-1.5">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-3.5 w-36" />
                  </div>
                </>
              ) : profile ? (
                <>
                  <Avatar className="size-12">
                    {profile.avatar_url && (
                      <AvatarImage src={profile.avatar_url} alt={profile.display_name} />
                    )}
                    <AvatarFallback>
                      {profile.display_name.charAt(0).toUpperCase()}
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate">{profile.display_name}</p>
                    <p className="text-xs text-muted-foreground truncate">{profile.email}</p>
                  </div>
                </>
              ) : null}
              <ChevronRight className="size-4 text-muted-foreground" />
            </CardContent>
          </Card>
        </Link>

        <div className="space-y-3">
          {menuItems.map((item) => (
            <Link key={item.to} to={item.to} className="block">
              <Card className="py-0 transition-colors hover:bg-accent">
                <CardContent className="flex items-center gap-4 px-4 py-4">
                  <item.icon className="size-5 text-muted-foreground" />
                  <span className="flex-1 text-sm font-medium">
                    {item.title}
                  </span>
                  <ChevronRight className="size-4 text-muted-foreground" />
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
